var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"timeout":_vm.adjustedTimeout,"color":_vm.snackBarColor},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[(_vm.showIcon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.snackBarIcon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }